const pageSizes: {[K in MapPrintSidebar['size']]: {width: number; height: number}} = {
    a2: {
        width: 16.5,
        height: 23.4,
    },
    a3: {
        width: 11.7,
        height: 16.5,
    },
    a4: {
        width: 8.3,
        height: 11.7,
    },
    tabloid: {
        width: 11,
        height: 17,
    },
    legal: {
        width: 8.5,
        height: 14,
    },
    letter: {
        width: 8.5,
        height: 11,
    },
};

export default pageSizes;
